import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import DropdownMenu from 'src/components/helperComponents/DropdownMenu'
import useDropdowns from 'src/hooks/useDropdowns'

const FilterPanel = ({ dispatcher, setCustomFilterQuery }) => {
  const { dropdowns } = useDropdowns()
  const dispatch = useDispatch()
  const location = useLocation()
  const courseDifficultyLevel = useSelector(
    store => store.mainReducer.courseDifficultyLevel
  )
  const courseList = dropdowns?.courses
  const [unitsList, setUnitList] = useState([])
  const [chaptersList, setChaptersList] = useState([])
  const [lessonList, setLessonList] = useState([])
  const [difficultyLevelList, setDifficultyLevelList] = useState(
    courseDifficultyLevel
  )
  const [lesson, setLesson] = useState('')
  const [difficultyLevel, setDifficultyLevel] = useState('')
  const [course, setCourse] = useState('')
  const [unit, setUnit] = useState('')
  const [chapters, setChapter] = useState('')

  const activeFilter = lesson || difficultyLevel || course || unit || chapters

  const onApplyFilter = () => {
    const query = {
      course: course,
      difficultyLevel: difficultyLevel === 'allLevels' ? '' : difficultyLevel,
      appliedCustomFilter: true,
      unit: unit === '-1' ? '' : unit,
      chapter: chapters === '-1' ? '' : chapters,
      lesson: lesson === '-1' ? '' : lesson,
    }
    setCustomFilterQuery(query)
    // dispatch(dispatcher(query))
  }
  const notShowFilter =
    location.pathname.indexOf('languages') !== -1 ||
    location.pathname.indexOf('entertainmentVideos') !== -1 ||
    location.pathname.indexOf('entertainmentVocabularies') !== -1 ||
    location.pathname.indexOf('customers') !== -1 ||
    location.pathname.indexOf('notifications') !== -1 ||
    location.pathname.indexOf('practice-item') !== -1 ||
    location.pathname.indexOf('banners') !== -1
  if (notShowFilter) {
    return null
  }

  const onLanguageChange = value => {
    setCourse(value)
    setDifficultyLevel('')
    setUnit('')
    setChapter('')
    setLesson('')
    setDifficultyLevelList(courseDifficultyLevel)
    let unitData = dropdowns?.units?.filter(item => item.course === value)
    setUnitList(unitData)
    let chaptersData = dropdowns?.chapters?.filter(
      item => item.course === value
    )
    setChaptersList(chaptersData)
    let lessonsData = dropdowns?.lessons?.filter(item => item.course === value)
    setLessonList(lessonsData)
  }

  const onDifficultyLevelChange = value => {
    setDifficultyLevel(value)
    setUnit('')
    setChapter('')
    setLesson('')
    let unitData = dropdowns?.units?.filter(
      item => item.course === course && item.difficultyLevel === value
    )
    setUnitList(unitData)
    let chaptersData = dropdowns?.chapters?.filter(
      item => item.course === course && item.difficultyLevel === value
    )
    setChaptersList(chaptersData)
    let lessonsData = dropdowns?.lessons?.filter(
      item => item.course === course && item.difficultyLevel === value
    )
    setLessonList(lessonsData)
  }
  const onUnitsChange = value => {
    setUnit(value)
    setChapter('')
    setLesson('')
    let chaptersData = dropdowns?.chapters?.filter(
      item => item.course === course && item.unit === value
    )
    if (difficultyLevel?.length > 0) {
      chaptersData = chaptersData?.filter(
        item => item.difficultyLevel === difficultyLevel
      )
    }
    setChaptersList(chaptersData)
    let lessonsData = dropdowns?.lessons?.filter(
      item => item.course === course && item.unit === value
    )
    if (difficultyLevel?.length > 0) {
      lessonsData = lessonsData?.filter(
        item => item.difficultyLevel === difficultyLevel
      )
    }
    setLessonList(lessonsData)
  }
  const onChapterChange = value => {
    setChapter(value)
    setLesson('')
    let lessonsData = dropdowns?.lessons?.filter(
      item => item.course === course && item.chapter === value
    )
    if (difficultyLevel?.length > 0) {
      lessonsData = lessonsData?.filter(
        item => item.difficultyLevel === difficultyLevel
      )
    }
    if (unit?.length > 0) {
      lessonsData = lessonsData?.filter(item => item.unit === unit)
    }
    setLessonList(lessonsData)
  }

  const onRest = () => {
    const query = {
      appliedCustomFilter: false,
    }
    setCourse('')
    setDifficultyLevelList([])
    setChaptersList([])
    setLessonList([])
    setUnitList([])
    setLesson('')
    setUnit('')
    setChapter('')
    setDifficultyLevel('')
    setCustomFilterQuery(query)
    dispatch(dispatcher(query))
  }

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      justifyContent="space-between"
      width="100%"
    >
      {/* Left side: dropdown filters */}
      <Grid item xs={12} md>
        <Grid container spacing={2} alignItems="center">
          {/* Language select dropdown */}
          <Grid item xs={12} sm={6} md={3}>
            <Box display="flex" justifyContent="center" alignItems="center" gap="5px">
              <h3>a&#41;</h3>
              <DropdownMenu
                value={course}
                label="Language"
                onChange={(e) => onLanguageChange(e.target.value)}
                data={courseList}
              />
            </Box>
          </Grid>

          {/* Difficulty Level select dropdown */}
          <Grid item xs={12} sm={6} md={3}>
            <Box display="flex" justifyContent="center" alignItems="center" gap="5px">
              <h3>b&#41;</h3>
              <DropdownMenu
                value={difficultyLevel}
                label="Difficulty Level"
                name="difficultyLevel"
                onChange={(e) => onDifficultyLevelChange(e.target.value)}
                data={difficultyLevelList}
              />
            </Box>
          </Grid>

          {/* Courses select dropdown */}
          {location.pathname.indexOf("courses") === -1 && (
            <Grid item xs={12} sm={6} md={3}>
              <Box display="flex" justifyContent="center" alignItems="center" gap="5px">
                <h3>c&#41;</h3>
                <DropdownMenu
                  value={unit}
                  label="Course"
                  name="Units"
                  onChange={(e) => onUnitsChange(e.target.value)}
                  data={unitsList}
                />
              </Box>
            </Grid>
          )}

          {/* Chapters select dropdown */}
          {(location.pathname.includes("lessons") ||
            location.pathname.includes("practice-list") ||
            location.pathname.includes("practice-item")) && (
              <Grid item xs={12} sm={6} md={3}>
                <Box display="flex" justifyContent="center" alignItems="center" gap="5px">
                  <h3>d&#41;</h3>
                  <DropdownMenu
                    value={chapters}
                    label="Chapters"
                    name="Chapters"
                    onChange={(e) => onChapterChange(e.target.value)}
                    data={chaptersList}
                  />
                </Box>
              </Grid>
            )}

          {/* Lesson select dropdown */}
          {(location.pathname.includes("practice-list") ||
            location.pathname.includes("practice-item")) && (
              <Grid item xs={12} sm={6} md={3}>
                <Box display="flex" justifyContent="center" alignItems="center" gap="5px">
                  <h3>e&#41;</h3>
                  <DropdownMenu
                    value={lesson}
                    label="Lesson"
                    name="Lesson"
                    onChange={(e) => setLesson(e.target.value)}
                    data={lessonList}
                  />
                </Box>
              </Grid>
            )}
        </Grid>
      </Grid>

      {/* Right side: buttons */}
      <Grid item xs={12} md="auto">
        <Grid container spacing={2} justifyContent={{ xs: "flex-start", md: "flex-end" }}>
          <Grid item>
            <Button
              disabled={!activeFilter}
              color="secondary"
              variant="contained"
              onClick={onApplyFilter}
              fullWidth={false}
            >
              Apply
            </Button>
          </Grid>
          <Grid item>
            <Button
              disabled={!activeFilter}
              color="secondary"
              variant="contained"
              onClick={onRest}
              fullWidth={false}
            >
              Reset
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>


  )
}

export default FilterPanel
